import React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '../translations/Translation';

const Banner = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(p) => p.theme.kallisto.color.common.special.myPrice[700]};
  padding: 12px 24px;
  gap: 16px;

  @media ${customCss.breakpoints.sm} {
    border-radius: 8px;
  }
`;

const BannerMyPrice = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  return (
    <Banner {...props}>
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          height: 48px;
          min-width: 48px;
          width: 48px;
          background-color: ${(p) => p.theme.kallisto.color.common.special.myPrice[500]};
          border-radius: 8px;
        `}
      >
        <img src={`${imageBasePath}icons/my_price_white.svg`} alt="icon" width={32} height={32} />
      </div>
      <div
        css={`
          color: white;
        `}
      >
        <Text variant="Title4" color="white">
          {t('vacation.select.details.myprice.banner.title')}
        </Text>
        <Text variant="BodySmall" color="white">
          {t('vacation.select.details.myprice.banner.description')}
        </Text>
      </div>
    </Banner>
  );
};

export default BannerMyPrice;
